import AuthorizedPages from "./authorizedPages";
import FreeExpiredGuard from "./components/FreeExpiredGuard";
import Menu from "./components/Menu";
import NavbarDashboard from "./components/NavbarDashboard";
import YoungLawyerWarningModal from "./components/YoungLawyerWarningModal";

const BaseLayout = ({ title, page, children }) => {
  return (
    <FreeExpiredGuard>
      <NavbarDashboard />
      <YoungLawyerWarningModal />

      <Menu />

      <div className="height"></div>

      <div
        style={{ height: "100%", minHeight: "100vh" }}
        className="container d-flex flex-wrap justify-content-center uk-margin-xlarge-bottom"
      >
        <div className="col-12 col-sm-12 col-md-10 col-lg-10 ">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 titlePage">
              <p className="fs-4 text-center fw-bold">{title}</p>
            </div>
            <AuthorizedPages page={page}>{children}</AuthorizedPages>
          </div>
        </div>
      </div>
    </FreeExpiredGuard>
  );
};

export default BaseLayout;
